import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Avatar,
  Box,
  Button,
  CardActions,
  ClickAwayListener,
  Divider,
  Grid,
  Paper,
  Popper,
  Stack,
  Typography,
  useMediaQuery,
  Badge,
} from "@mui/material";

import PerfectScrollbar from "react-perfect-scrollbar";

import MainCard from "ui-component/cards/MainCard";
import Transitions from "ui-component/extended/Transitions";
import NotificationList from "./NotificationList";

import { IconBell } from "@tabler/icons";
import { getHeaderNotification } from "store/slices/headerNotificationAction";
import {
  notificationAlert,
  getUnreadData,
} from "store/slices/notificationAction";
import { connect, useSelector } from "react-redux";

// ==============================|| NOTIFICATION ||============================== //

const NotificationSection = (props) => {
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down("md"));
  const { adminLabelsName } = props.label;
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(3);

  const notifications = useSelector((state) => state.headerNotification);
  const { loading, headerNotificationList } = notifications;

  const notifications1 = useSelector((state) => state.notifications);
  const { notificationData } = notifications1;
  const unreads = notificationData;

  useEffect(() => {
    props.getUnreadData();
  }, []);

  useEffect(() => {


    props.getHeaderNotification(1, rowsPerPage, "");
  }, []);



  /**
   * anchorRef is used on different componets and specifying one type leads to other components throwing an error
   * */
  const anchorRef = useRef(null);

  const handleToggle = () => {

    setOpen((prevOpen) => !prevOpen);
    const notify = [];
    let b = headerNotificationList.docs.length;
    for (let i = 0; i < b; i++) {
      notify.push(headerNotificationList.docs[i]._id);
    }
    let datas = { id: notify, flag: 2 };

    props.notificationAlert(datas);
    props.getUnreadData();
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <Box
        sx={{
          ml: 2,
          mr: 3,
          [theme.breakpoints.down("md")]: {
            mr: 2,
          },
        }}
      >
        <Badge badgeContent={unreads} color="primary">
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              transition: "all .2s ease-in-out",
              background:
                theme.palette.mode === "dark"
                  ? theme.palette.dark.main
                  : theme.palette.secondary.light,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.warning.dark
                  : theme.palette.secondary.dark,
              '&[aria-controls="menu-list-grow"],&:hover': {
                background:
                  theme.palette.mode === "dark"
                    ? theme.palette.warning.dark
                    : theme.palette.secondary.dark,
                color:
                  theme.palette.mode === "dark"
                    ? theme.palette.grey[800]
                    : theme.palette.secondary.light,
                    borderColor: theme.palette.primary.main,
              },
            }}
            ref={anchorRef}
            aria-controls={open ? "menu-list-grow" : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
            color="inherit"
          >
            <IconBell stroke={1.5} size="1.3rem" />
          </Avatar>
        </Badge>
      </Box>

      <Popper
        placement={matchesXs ? "bottom" : "bottom-end"}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [matchesXs ? 5 : 0, 20],
              },
            },
          ],
        }}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <Transitions
              position={matchesXs ? "top" : "top-right"}
              in={open}
              {...TransitionProps}
            >
              <Paper
                sx={{
                  [theme.breakpoints.down("md")]: {
                    mx: 1.5,
                  },
                  [theme.breakpoints.down("sm")]: {
                    mx: 0,
                  },
                }}
              >
                {open && (
                  <MainCard
                    border={false}
                    elevation={16}
                    content={false}
                    boxShadow
                    shadow={theme.shadows[16]}
                  >
                    <Grid container direction="column" spacing={2}>
                      <Grid item xs={12}>
                        <Grid
                          container
                          alignItems="center"
                          justifyContent="space-between"
                          sx={{ pt: 2, px: 2 }}
                        >
                          <Grid item>
                            <Stack direction="row" spacing={2}>
                              <Typography variant="subtitle1" sx={{fontSize:"12px"}}>
                                {adminLabelsName
                                  ? adminLabelsName.filter(
                                      (e) => e.key == "lbl_notification"
                                    ).length > 0
                                    ? adminLabelsName.filter(
                                        (e) => e.key == "lbl_notification"
                                      )[0]["value"] || "lbl_notification"
                                    : "lbl_notification"
                                  : "lbl_notification"}
                              </Typography>
                            </Stack>
                          </Grid>
                          <Grid item></Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <PerfectScrollbar
                          style={{
                            height: "100%",
                            maxHeight: "calc(100vh - 205px)",
                            overflowX: "hidden",
                          }}
                        >
                          <Grid container direction="column" spacing={2}>
                            <Grid item xs={12} p={0}>
                              <Divider sx={{ my: 0 }} />
                            </Grid>
                          </Grid>
                          <NotificationList
                            notificationList={headerNotificationList}
                            loading={loading}
                          />
                        </PerfectScrollbar>
                      </Grid>
                    </Grid>
                    <Divider />
                    <CardActions sx={{ p: 1.25, justifyContent: "center" }}>
                      <Link
                        to="/notification"
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          size="small"
                          disableElevation
                          onClick={(e) => {
                            setOpen(false);
                          }}
                         variant="contained"
                          sx={{fontSize:"12px"}}
                        >
                          View All
                        </Button>
                      </Link>
                    </CardActions>
                  </MainCard>
                )}
              </Paper>
            </Transitions>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
};
const mapStateToProps = (state) => ({
  label: state.language,
});

export default connect(mapStateToProps, {
  getHeaderNotification,
  notificationAlert,
  getUnreadData,
})(NotificationSection);
